import { Users } from '~/types/users';

export default function isFullUser(
  user: Users.User | undefined | null
): user is Users.FullUser {
  return user?.isGuest === false;
}
